import { KeyValuePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { AffiliatesTierCardComponent } from '@features/engagement/affiliates/affiliates-tier-card/affiliates-tier-card.component';
import { AffiliatesService } from '@features/engagement/affiliates/services/affiliates.service';
import { AFFILIATES_DEFAULT_TIER } from '@features/engagement/affiliates/configs/affiliates-tiers.config';

@Component({
  selector: 'app-affiliates-tiers-modal',
  imports: [AffiliatesTierCardComponent, KeyValuePipe],
  templateUrl: './affiliates-tiers-modal.component.html',
  styleUrl: './affiliates-tiers-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class AffiliatesTiersModalComponent {
  public readonly affiliatesService = inject(AffiliatesService);

  /** Highlight the player's real tier; guests / unloaded basics show tier 1. */
  readonly activeTierKey = computed(
    () =>
      this.affiliatesService.userTiers().currentTier?.fe_tier ??
      AFFILIATES_DEFAULT_TIER
  );
}
